jQuery( document ).ready(function($) {
    const menuToggleClass = 'showed-menu';

    $('#top-bar-menu').click(function () {
        $('html').toggleClass(menuToggleClass);
    });
});

/**
 * Forces all PDF links to download automatically, if the browser supports it.
 * Otherwise, open the link in a new browser window or tab.
 */
jQuery(document).ready(function($) {
    $('.download')
        .attr('download', '')
        .attr('target', '_blank');
});